"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManufacturerInfoFromMsn = exports.ManufacturerInfo = exports.Msn = void 0;
const effect_1 = require("effect");
const DateSchema = __importStar(require("../../../../date"));
const schema_1 = require("../../../../schema");
const NAMESPACE = 'Culligan.Device.Class.HydroTapBridge.Msn';
const dayOfMonthPatternWithZero = String.raw `(00)|(${DateSchema.dayOfMonthPattern})`;
const msnPattern = String.raw `^` +
    String.raw `(?<year>\d{4})` + // any 4 digits
    String.raw `(?<month>${DateSchema.monthNumberPattern})` + // 2 digits, [01-12]
    String.raw `(?<day>${dayOfMonthPatternWithZero})` + // 2 digits, [00-31]
    String.raw `(?<productionLineNumber>\d{2})` + // any 2 digits
    String.raw `(?<incremental>\d{3})` + // any 3 digits
    String.raw `$`;
exports.Msn = effect_1.Schema.String.pipe(effect_1.Schema.pattern(new RegExp(msnPattern))).annotations({
    identifier: `${NAMESPACE}.Msn`,
    title: 'Manufacturing Serial Number',
    documentation: `\
YYYYMMDDLLNNN
YYYY, MM, DD = Year/Month/Day of manufacturer
LL = production line number
NNN = incrementing number. resets every day`,
    examples: ['2021031551001'],
});
class ManufacturerInfo extends effect_1.Schema.Class(`${NAMESPACE}.ManufacturerInfo`)({
    year: effect_1.Schema.NumberFromString.pipe(effect_1.Schema.int(), effect_1.Schema.between(0, 9999)),
    month: effect_1.Schema.NumberFromString.pipe(effect_1.Schema.int(), effect_1.Schema.between(1, 12)),
    day: effect_1.Schema.NumberFromString.pipe(effect_1.Schema.int(), effect_1.Schema.between(0, 31)),
    productionLineNumber: effect_1.Schema.NumberFromString.pipe(effect_1.Schema.int(), effect_1.Schema.between(0, 99)),
    incremental: effect_1.Schema.NumberFromString.pipe(effect_1.Schema.int(), effect_1.Schema.between(0, 999)),
}) {
    static serialize(info) {
        return [
            String(info.year).padStart(4, '0'),
            String(info.month).padStart(2, '0'),
            String(info.day).padStart(2, '0'),
            String(info.productionLineNumber).padStart(2, '0'),
            String(info.incremental).padStart(3, '0'),
        ].join('');
    }
    serialize() {
        return ManufacturerInfo.serialize(this);
    }
}
exports.ManufacturerInfo = ManufacturerInfo;
exports.ManufacturerInfoFromMsn = (0, schema_1.CapturePattern)(new RegExp(msnPattern), ManufacturerInfo, (_toI, _options, _ast, toA) => effect_1.Effect.succeed(ManufacturerInfo.serialize(toA))).annotations({
    identifier: `${NAMESPACE}.ManufacturerInfoFromMsn`,
});
//# sourceMappingURL=msn.js.map